document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-iss-story]').forEach(function (story) {
    var slides = story.querySelectorAll('[data-iss-slide]');
    var fills = story.querySelectorAll('[data-iss-fill]');
    var prevBtn = story.querySelector('[data-iss-prev]');
    var nextBtn = story.querySelector('[data-iss-next]');
    var duration = parseInt(story.getAttribute('data-duration'), 10) || 4000;

    if (!slides.length) return;

    var current = 0;
    var paused = false;
    var timer = null;

    function setActiveSlide(index) {
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      fills.forEach(function (fill, i) {
        fill.classList.remove('is-animating');
        if (i < index) {
          fill.classList.add('is-complete');
          fill.style.width = '100%';
          fill.style.transitionDuration = '0s';
        } else if (i === index) {
          fill.classList.remove('is-complete');
          fill.style.width = '0%';
          fill.style.transitionDuration = '0s';
          // Force reflow so the transition below actually animates from 0
          void fill.offsetWidth;
        } else {
          fill.classList.remove('is-complete');
          fill.style.width = '0%';
          fill.style.transitionDuration = '0s';
        }
      });
    }

    function startFill() {
      var activeFill = fills[current];
      if (!activeFill) return;
      requestAnimationFrame(function () {
        activeFill.classList.add('is-animating');
        activeFill.style.transitionDuration = duration + 'ms';
        activeFill.style.width = '100%';
      });
    }

    function goTo(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;
      current = index;
      setActiveSlide(current);
      startFill();
      resetTimer();
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function resetTimer() {
      clearTimeout(timer);
      if (paused) return;
      timer = setTimeout(next, duration);
    }

    function pause() {
      paused = true;
      clearTimeout(timer);
      fills.forEach(function (fill) {
        var computed = getComputedStyle(fill).width;
        fill.style.transitionDuration = '0s';
        fill.style.width = computed;
      });
    }

    function resume() {
      if (!paused) return;
      paused = false;
      var activeFill = fills[current];
      if (activeFill) {
        var currentWidth = parseFloat(getComputedStyle(activeFill).width);
        var trackWidth = activeFill.parentElement.offsetWidth;
        var remainingRatio = 1 - currentWidth / trackWidth;
        var remainingMs = Math.max(remainingRatio * duration, 100);
        requestAnimationFrame(function () {
          activeFill.classList.add('is-animating');
          activeFill.style.transitionDuration = remainingMs + 'ms';
          activeFill.style.width = '100%';
        });
        timer = setTimeout(next, remainingMs);
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    // Press and hold to pause, like Instagram Stories
    ['mousedown', 'touchstart'].forEach(function (evt) {
      story.addEventListener(evt, pause, { passive: true });
    });
    ['mouseup', 'mouseleave', 'touchend', 'touchcancel'].forEach(function (evt) {
      story.addEventListener(evt, resume, { passive: true });
    });

    // Swipe support
    var touchStartX = 0;
    story.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    story.addEventListener(
      'touchend',
      function (e) {
        var touchEndX = e.changedTouches[0].screenX;
        var diff = touchEndX - touchStartX;
        if (Math.abs(diff) > 40) {
          if (diff < 0) {
            next();
          } else {
            prev();
          }
        }
      },
      { passive: true }
    );

    goTo(0);
  });
});